export default __webpack_public_path__ + "static/media/gd-explain.8aebb83e.svg";